// extracted by mini-css-extract-plugin
export default {"buttonWrapper":"shareButton-module--buttonWrapper--Ll6rb","shareButton":"shareButton-module--shareButton--2MxCK"};